<template>
  <v-container fluid>
    <v-col cols="12">
      <v-card>
        <v-card-title class="headline">
          担当者管理
          <v-spacer></v-spacer>
          <v-btn
              v-if="this.$store.getters['auth/user_edit_role'] === 2 && this.$store.getters['auth/store_assign_role'] === 2"
              rounded
              outlined
              class="common-cancel-btn"
              @click="addUser()"
          >
            新規登録
            <v-icon
                right
                dark
            >
              mdi-plus
            </v-icon>
          </v-btn>
          <v-btn
              v-if="this.$store.getters['auth/user_edit_role'] === 2 && this.$store.getters['auth/store_assign_role'] === 2"
              rounded
              outlined
              class="common-cancel-btn ml-3"
              @click.stop="openDialog"
          >
            CSV入出力
            <v-icon
                right
                dark
            >
              mdi-swap-vertical
            </v-icon>
          </v-btn>
          <CsvDialog
              ref="dlg"
              @dialogClose="getUserList()"
          ></CsvDialog>
          <v-dialog v-model="dialog"></v-dialog>
        </v-card-title>
        <v-divider class="mx-3"></v-divider>
        <v-card-text>
          <v-data-table
              :headers="headers"
              :items="users"
              hide-default-footer
              disable-pagination
              sort-by="calories"
              class="no-shadow"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon
                  small
                  class="common-edit-icon mr-2"
                  @click="editUser(item.id)"
              >
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-container>
</template>


<script>
import axios from "axios";
import CsvDialog from "./components/CsvDialog.vue";

export default {
  components: {
    CsvDialog
  },
  data: () => ({
    headers: [
      {
        text: 'No',
        align: 'start',
        sortable: false,
        value: 'no',
      },
      { text: '担当者コード', value: 'user_code', sortable: false },
      { text: '担当者名称', value: 'name', sortable: false },
      { text: '権限', value: 'user_edit_role_name', sortable: false },
      { text: '有効期限(from)', value: 'expires_date_from', sortable: false },
      { text: '有効期限(to)', value: 'expires_date_to', sortable: false },
      { text: '', value: 'actions', sortable: false },
    ],
    users: [],
    dialog: false,
  }),

  mounted () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.getUserList();
      this.$refs.dlg.isDisplay = false
    },
    async getUserList() {
      const response = await axios.get('/user')
      const result = response.data?.result || 0
      const data = response.data?.data || null

      if(result === true && data !== null) {
        let no = 1;
        data.forEach(function(user){
          user['no'] = no;
          no++;
        })
        this.users = data
      }
    },
    editUser (userId) {
      this.$router.push('/users/edit/' + userId)
    },
    addUser() {
      this.$router.push('/users/new')
    },
    openDialog() {
      this.$refs.dlg.isDisplay = true
    }
  },
}
</script>